import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Channels from './Channels'
import { actions } from '../../store'

const mapStateToProps = state => ({
  table: state.storage.table,
  channel: state.channel,
  storage: state.storage,
  files: state.storage.data.files,
  filters: state.storage.filters,
  selectedChannel: state.channel.selectedChannel,
  selectedDirectory: state.channel.selectedDirectory,

  channels: state.channel,
  selectedDirectoryStack: state.channel.selectedDirectoryStack,
  tableChannels: state.channel.table,
  users: state.user.list,
  groups: state.group.list
})

const mapDispatchToProps = dispatch => bindActionCreators({
  setModal: actions.modal.setModal,
  setTable: actions.storage.setTable,
  addTableItem: actions.storage.addTableItem,
  removeTableItem: actions.storage.removeTableItem,

  createStorageAssignmentByArray: actions.storage.createStorageAssignmentByArray,
  selectDirectory: actions.channel.selectDirectory,
  getChannelById: actions.channel.getChannelById,
  toPreviousPage: actions.channel.toPreviousPage,
  updateTable: actions.channel.updateTable,
  clearSelectedChannel: actions.channel.clearSelectedChannel,
  clearSelectedDirectory: actions.channel.clearSelectedDirectory,
  addUsers: actions.channel.addUsers,
  deleteUsers: actions.channel.deleteUsers,
  addGroups: actions.channel.addGroups,
  deleteGroups: actions.channel.deleteGroups,
  lock: actions.channel.lock,
  unlock: actions.channel.unlock,

  setFilterPagination: actions.storage.setFilterPagination,
  clearFilters: actions.storage.clearFilters,

  getStorage: actions.storage.getStorage,
  getTags: actions.tag.getTags,
  getChannels: actions.channel.getChannels,
  getUsers: actions.user.getUsers,
  getGroups: actions.group.getGroups
}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Channels)



// WEBPACK FOOTER //
// ./src/views/Channels/index.js